import React from "react"
import { Wrap, Tag } from "@chakra-ui/react"

export function TagManager({
  setActiveTags,
  handleClick,
  activeTags,
  tags,
  ...rest
}) {
  const toggleActiveTag = tag => {
    activeTags.includes(tag)
      ? setActiveTags(activeTags.filter(i => i !== tag))
      : setActiveTags([...activeTags, tag])
  }

  const handleTagClick = tag => {
    handleClick && handleClick()
    toggleActiveTag(tag)
  }

  return (
    <Wrap {...rest} justify="center">
      {tags.map((tag, index) => (
        <Tag
          {...(activeTags.includes(tag) && {
            color: "gray.d100",
            bg: "primary.200",
          })}
          _hover={{
            color: activeTags.includes(tag) ? "gray.d100" : "text.300",
          }}
          onClick={() => handleTagClick(tag)}
          transition="200ms ease"
          colorScheme="base"
          variant="subtle"
          key={index}
          as="button"
        >
          {tag}
        </Tag>
      ))}
    </Wrap>
  )
}
